var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-popped-alert",class:{ 'v-popped-alert--opened': _vm.isOpen }},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }